module.exports = flarum.core.compat['components/EditUserModal'];